import { useCallback, useRef, useState } from "react"
import { toast } from "sonner"

type UseCopyToClipboardProps = {
  text: string
  copyMessage?: string
  errorMessage?: string
}

export function useCopyToClipboard({ text, copyMessage, errorMessage }: UseCopyToClipboardProps) {
  const [isCopied, setIsCopied] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const onCopy = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      e.stopPropagation()

      navigator.clipboard
        .writeText(text)
        .then(() => {
          if (copyMessage) {
            toast.success(copyMessage)
          }
          setIsCopied(true)
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
          }
          timeoutRef.current = setTimeout(() => {
            setIsCopied(false)
          }, 2000)
        })
        .catch(() => {
          if (errorMessage) {
            toast.error(errorMessage)
          }
        })
    },
    [text, copyMessage, errorMessage],
  )

  return { isCopied, onCopy }
}
